import React from 'react';
import { Popover, Input, CancelIcon } from 'elmo-elements';
import cx from 'classnames';
import { DatePickerCalendar } from './components/DatePickerCalendar';
import { StyledDatePickerPopoverWrapper } from './styles';
import type { TDatePickerProps } from './types';
import { useDatePickerState } from './hooks/useDatePickerState';

export const DatePicker = (props: TDatePickerProps) => {
    const { id, className, name, isDisabled, isClearable, placeholder } = props;
    const {
        selectedDate,
        selectedDateString,
        handleClear,
        handleCheckIsDateDisabled,
        onDateSelect,
        timeZone,
    } = useDatePickerState(props);

    return (
        <StyledDatePickerPopoverWrapper
            id={id}
            className={cx(className)}
            data-testid="elmo-datepicker-default"
        >
            <Popover isAutoWidth isNoPadding mode="click" position="bottom-start">
                <Popover.Target>
                    <Input
                        name={name}
                        isReadOnly
                        isDisabled={isDisabled}
                        value={selectedDateString}
                        placeholder={placeholder}
                    />
                    {isClearable && !isDisabled && selectedDate && (
                        <button
                            type="button"
                            className="btn-clear"
                            onClick={handleClear}
                            aria-label="Clear"
                        >
                            <CancelIcon />
                        </button>
                    )}
                </Popover.Target>
                <Popover.Content>
                    <DatePickerCalendar
                        selectedDate={selectedDate}
                        handleCheckIsDateDisabled={handleCheckIsDateDisabled}
                        onDateSelect={onDateSelect}
                        timeZone={timeZone}
                    />
                </Popover.Content>
            </Popover>
        </StyledDatePickerPopoverWrapper>
    );
};
